import * as React from "react";
import type { SVGProps } from "react";
const SvgNesmaAirlines = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 50 50"
    width="100%"
    height="100%"
    {...props}
  >
    <g fill="#646263">
      <path d="M23.11 31.494c0 1.256-.594 1.888-1.791 1.888q-.818-.002-1.86-.797L4.267 20.605v11.604c0 .54-.233.869-.705 1.006-.247.054-.717.085-1.414.085C1.38 33.3 1 32.942 1 32.222v-13.83c0-1.2.56-1.798 1.672-1.798q1.058-.001 2.165.865L19.84 29.303V17.789c0-.527.232-.857.707-.986q.361-.088 1.405-.088 1.157-.001 1.158 1.063zM41.192 26.534l-4.881-7.202-4.915 7.202zM49 32.637q-.001.66-.452 1.11-.44.449-1.114.448c-.617 0-1.116-.285-1.507-.867l-2.854-4.133H29.52l-2.862 4.133c-.309.45-.637.684-.995.684-.356 0-.7-.121-1.027-.35-.372-.248-.552-.548-.552-.885q0-.159.082-.288l10.167-15.537q.631-.954 2.15-.952 1.128-.002 1.507.637c.021.027.04.065.067.12.016.057.057.121.113.195l10.777 15.246c.033.075.054.212.054.439" />
    </g>
  </svg>
);
export default SvgNesmaAirlines;
